<!--
//================================================================================
// ID:BC051
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC051
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.02.00 | 2022/10/07 | 富士通Japan株式会社    | 新規作成
// 01.03.00 | 2023/09/27 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__main--list">
		<error-message />
		<!--◆編集エリア START◆-->
		<div class="ichiran__main">
			<div class="ichiran__contents">
				<span class="contents__research">
					<label class="margin__right-5">条件を変更して検索</label>
					<input type="button" class="contents__btn--cancel" value="再検索" v-on:click="clickReSearchBtn()" tabindex="130">
				</span>
			</div>
			<pagination
				:sortType="SORT_KIND.KANRI"
				:name="'ページヘッダー'"
				:class="'margin__bottom-8'"
				:listCount="form.listCount"
				:displaySortFlg="true"
				:tabindex="1"
				:clickSortList="clickSortListBtn"
				:clickPageSwitch="clickPageSwitchBtn"
				ref="pageHeader" />
			<div align="center">
				<div class="contents__div--PC">
				<table border="1" class="contents__table--itiran ichiran-back" id="list">
					<thead>
						<tr id="listheader">
							<th id="listtitle01">
							入居人数
							</th>
							<th id="listtitle02">申込地区番号<br>
							</th>
							<th id="listtitle03">
							住宅名<br>
							代表的な所在地<br>
							主な交通機関
							</th>
							<th id="listtitle04">募集<br />戸数</th>
							<th id="listtitle05">残<br />戸数</th>
							<th id="listtitle06">間取り<br>専用面積<br />(m&sup2;)</th>
							<th  id="listtitle07">
							建設年度<br>
							エレベーター</th>
							<th id="listtitle08">
							使用料(円)
							</th>
							<th id="listtitle09">状況</th>
							<th id="listtitle10">公開期間</th>
						</tr>
					</thead>
					<tbody>
						<tr id="listcountents" v-on:click="clickMeisai(row)" v-for="row in form.meisaiList" :key="row.viewNoMouchiku">
							<td id="listtd">{{ row.nyukyoSu }}</td>
							<td id="listtd">{{ row.noMouchiku }}</td>
							<td id="listjyusho">
								<label id="list1">{{ row.jyutakuName }}</label><br />
								<label id="list2">{{ row.kusicyo }}</label><br />
								<label id="list3">{{ row.trans }}</label>
							</td>
							<td id="listtd">{{ row.nuBosyukosu }}</td>
							<td id="listtd">{{ row.zankosu }}</td>
							<td id="listtd" class="contents__kaigyo--css">{{ row.madori }}<br />{{ row.senyoArea }}</td>
							<td id="listtd" v-if="row.kensetuLow == null && row.kensetuUpr == null">
								<label><br />{{ row.elevatorUmu }}</label>
							</td>
							<td id="listtd" v-else-if="row.kensetuUpr == null">
								<label>{{ row.kensetuLow }}<br />{{ row.elevatorUmu }}</label>
							</td>
							<td id="listtd" v-else>
								<label>{{ row.kensetuLow }}～<br />{{ row.kensetuUpr }}<br />{{ row.elevatorUmu }}</label>
							</td>
							<td id="listtd" v-if="row.moSiyoryoLow == null && row.moSiyoryoUpr == null">
								<label><br /></label>
							</td>
							<td id="listtd" v-else-if="row.moSiyoryoUpr == null">
								<label>{{ co_commaSeparated(row.moSiyoryoLow) }}</label>
							</td>
							<td id="listtd" v-else>
								<label>{{ co_commaSeparated(row.moSiyoryoLow) }}～<br />{{ co_commaSeparated(row.moSiyoryoUpr) }}</label>
							</td>
							<td id="listtd">
								<label v-if="row.zyokyo ==='公開予定'" class="contents__koukaiyotei">{{ row.zyokyo }}</label>
								<label v-else-if="row.zyokyo ==='公開中'" class="contents__koukai">{{ row.zyokyo }}</label>
								<label v-else-if="row.zyokyo ==='変更予定'" class="contents__henkoyotei">{{ row.zyokyo }}</label>
								<label v-else class="contents__koukaisyuryo">{{ row.zyokyo }}</label>
							</td>
							<td id="listtd">
								<label v-if="row.zyokyo ==='公開予定'|| row.zyokyo ==='公開中'">{{ co_editDateTimeSlash(row.viewKokaiStt) }}<br />～<br />{{ co_editDateTimeSlash(row.viewKokaiEnd) }}</label>
								<label v-else-if="row.zyokyo ==='変更予定'">{{co_editDateTimeSlash( row.viewTekiyoStt) }}<br />～<br />{{ co_editDateTimeSlash(row.viewKokaiEnd) }}</label>
								<label v-else></label>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<pagination
				:sortType="SORT_KIND.KANRI"
				:name="'ページフッター'"
				:class="'margin__top-10 margin-bottom-foot'"
				:listCount="form.listCount"
				:displaySortFlg="true"
				:displayFotterFlg="true"
				:tabindex="120"
				:clickSortList="clickSortListBtn"
				:clickPageSwitch="clickPageSwitchBtn"
				ref="pageFotter" />
			</div>
		</div>
    <!--◆編集エリア END◆-->
	</div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import Pagination from '@/components/Pagination.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_commaSeparated,co_editDateTimeSlash} from '@/common/stringUtility.js';
import { co_toTop, co_toTrans, co_clearParam } from '@/common/screenUtility.js';
import { co_errorDialog } from '@/common/dialogUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { STORE_DATA_GETDATA } from '@/const/store.js';
import { HTTP_STATUS,SORT_KIND,DIALOG_BUTTON_LIST_KEY } from '@/const/const.js';
import { STORE_DATA_ADD_DATA,STORE_ERROR_CLEAR, STORE_VIEW_PROGRESS,STORE_VIEW_GET_SORT_ORDER, STORE_VIEW_GET_PARAMS } from '@/const/store.js';
import { PATH_BC051,PATH_BC051_COUNT } from '@/const/route.js';

export default {
	name: "BC051",
	components: {
		'error-message': ErrorMessage,
		'pagination': Pagination,
	},
	data: function () {
		return {
			form: {
				kbBosyu:	'',			// 募集の種類(明細カウント用)
				jyutakuKind: '',		// 住宅の種別
				ymBosyu: '',			// 募集年月
				nyukyoNinzu: '',		// 入居人数
				kushicyoList: [],		// 区市町リスト
				zyokyo: '',				// 状況
				koukaikaishi:'',		// 公開開始日(表示用)
				tekiyokaishi:'',		// 適用開始日(表示用)
				koukaisyuryo:'',		// 公開終了日(表示用)
				koukaikaishiFrom:'',	// 公開開始日(From)
				koukaikaishiTo:'',		// 公開開始日(To)
				koukaisyuryoFrom:'',	// 公開終了日(From)
				koukaisyuryoTo:'',		// 公開終了日(To)
				tekiyokaishiFrom:'',	// 変更反映(適用開始)日(From)
				tekiyokaishiTo:'',		// 変更反映(適用開始)日(To)
				noMouchiku: '',			// 申込地区番号
				jyutakuName: '',        // 住宅名
				meisaiList: [],         // 募集住宅一覧リスト(表示用)
				listCount: 0,           // 募集住宅一覧件数
				souPageCnt: 0,          // 総ページ数
				dmTekiyoStt: ''			// 適用開始日(明細カウント用)
			},
			disp: {
				bosyuJyutakuList: [],   // 募集住宅情報リスト
			},
			co_commaSeparated: co_commaSeparated,
			co_editDateTimeSlash: co_editDateTimeSlash,
			SORT_KIND: SORT_KIND,
		}
	},
	mounted: async function () {
		await this.$nextTick();

		if (this.form.bosyuKind != '') {
			// フォーカス設定
			this.$refs.pageHeader.focus();
		}

	},
	created: async function() {

		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// 前画面からのパラメータを設定
		let param = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC051');

		// 画面間パラメータを削除
		co_clearParam('BC051');

		let data = [];
		if (typeof param != 'undefined') {
			data = param.paramData;
		}
		if (data.length === 0) {
			// 状態管理（ストア）から前回情報を取得
			data = this.$store.getters[STORE_DATA_GETDATA]('BC051');

			if (data === null) {
				// 前回情報が存在しない場合、ログイン画面に遷移
				co_toTrans('BC001');
				return;
			}
		}

		// フォームに検索条件を代入
		this.form.jyutakuKind = data.jyutakuKind;
		this.form.ymBosyu = data.ymBosyu;
		this.form.nyukyoNinzu = data.nyukyoNinzu;
		this.form.jyutakuName = data.jyutakuName;
		this.form.noMouchiku = data.noMouchiku;
		this.form.zyokyo = data.zyokyo;
		this.form.kushicyoList = data.kushicyoList;
		this.form.koukaikaishiFrom = data.koukaikaishiFrom;
		this.form.koukaikaishiTo = data.koukaikaishiTo;
		this.form.koukaisyuryoFrom = data.koukaisyuryoFrom;
		this.form.koukaisyuryoTo = data.koukaisyuryoTo;
		this.form.tekiyokaishiFrom = data.tekiyokaishiFrom;
		this.form.tekiyokaishiTo = data.tekiyokaishiTo;

		// 入力値保持
		this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC051', data: this.form });

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		let self = this;
		let listData = await co_post(PATH_BC051, this.form, function (res, handle) {

			if (res.status == HTTP_STATUS.OK) {
				return handle(res);
			} else {
				// ローディング表示終了
				self.$store.commit(STORE_VIEW_PROGRESS, false);
			}
		});

		if (listData == null || listData.jyutakuList.length == 0 ) {
			// 検索結果無し
			co_errorDialog(co_getMessage('E0014'), this.doPageBack);
			return;
		}

		// 募集住宅情報を一覧に設定
		this.disp.bosyuJyutakuList = this.doSortList('08',listData.jyutakuList);
		this.form.meisaiList = this.disp.bosyuJyutakuList;
		this.form.listCount = this.form.meisaiList.length;

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);

	},
	computed: {
		beforePageFlg: function () {
			if (this.form.souPageCnt <= 5) {
				return false;
			} else {
				return true;
			}
		},
	},
	methods: {
		// 再検索ボタン押下処理
		clickReSearchBtn: function () {

			// 住宅検索(随時募集・管理者用)画面に遷移
			co_toTrans('BC050');
		},
		// 並び替えボタン押下処理
		clickSortListBtn: function (sortType, startIndex, endIndex) {

			this.disp.bosyuJyutakuList = this.doSortList(sortType, this.disp.bosyuJyutakuList);
			let eitMeisaiList = [];
			for (let i = startIndex; i < endIndex; i++) {
				eitMeisaiList.push(this.disp.bosyuJyutakuList[i]);
			}
			this.form.meisaiList = eitMeisaiList;
		},
		// 並び替え処理
		doSortList: function (sortType, dataList) {

			switch (sortType){

				// 申込地区番号順
				case '08':
					dataList.sort( (a,b) => {
						return Number(a.viewNoMouchiku - b.viewNoMouchiku);
					});
					break;

				// 区市順
				case '11':
					dataList.sort( (a,b) => {
					if (a.cdKusicyoson !== b.cdKusicyoson) {
						a.cdKusicyoson - b.cdKusicyoson;
						return a.cdKusicyoson - b.cdKusicyoson;
					}
					return a.viewNoMouchiku - b.viewNoMouchiku;
					});
					break;

				// 公開開始日（昇順）
				case '12':
					dataList.sort( (a,b) => {
					if (a.kokaiStt !== b.kokaiStt) {
						return a.kokaiStt - b.kokaiStt;
					}
					return a.viewNoMouchiku - b.viewNoMouchiku;
					});
					break;

				//公開開始日（降順）
				case '13':
					dataList.sort( (a,b) => {
					if (a.kokaiStt !== b.kokaiStt) {
						return b.kokaiStt - a.kokaiStt;
					}
					return a.viewNoMouchiku - b.viewNoMouchiku;
					});
					break;

				// 残戸数が多い順
				case '09':
					dataList.sort( (a,b) => {
					if (a.zankosu !== b.zankosu) {
						return b.zankosu - a.zankosu;
					}
					return a.viewNoMouchiku - b.viewNoMouchiku;
					});
					break;

				// 残戸数が少ない順
				case '10':
					dataList.sort( (a,b) => {
					if (a.zankosu !== b.zankosu) {
						return a.zankosu - b.zankosu;
					}
					return a.viewNoMouchiku - b.viewNoMouchiku;
					});
					break;
			}
			return dataList;
		},
		// ページ切替ボタン押下処理
		clickPageSwitchBtn: function (startIndex, endIndex) {

			let sortOrder = this.$store.getters[STORE_VIEW_GET_SORT_ORDER];
			if (sortOrder != '') {
				this.disp.bosyuJyutakuList = this.doSortList(sortOrder, this.disp.bosyuJyutakuList);
			}

			let eitMeisaiList = [];
			for (let i = startIndex; i < endIndex; i++) {
				eitMeisaiList.push(this.disp.bosyuJyutakuList[i]);
			}
			this.form.meisaiList = eitMeisaiList;

			// ページトップへ遷移
			co_toTop();
		},
		// 明細押下処理
		clickMeisai: async function (row) {

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			this.form.kbBosyu =	row.kbBosyu;
			this.form.jyutakuKind = row.kbZyutaku;
			this.form.ymBosyu = row.ymBosyu;
			this.form.noMouchiku = row.noMouchiku;
			this.form.dmTekiyoStt = row.viewTekiyoStt;

			let meisaiCount = await co_post(PATH_BC051_COUNT,this.form);

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			if (meisaiCount === 0) {
				co_errorDialog(co_getMessage('E0110'), this.doDialogClick);
				return;
			} else {
				// 募集住宅情報画面に遷移
				let params = {
								bosyuKind: row.kbBosyu,
								jyutakuKind: row.kbZyutaku,
								ymBosyu: row.ymBosyu,
								noMouchiku: row.noMouchiku,
								tekiyokaishi: row.viewTekiyoStt,
								zyokyo: row.zyokyo
							};
				co_toTrans('BC052', params);
			}
		},
		doDialogClick: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return;
			}
		},
		// 検索結果無しダイアログ「OK」ボタン押下時処理
		doPageBack: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// 住宅検索(随時募集・管理者用)画面に遷移
				co_toTrans('BC050');
			}
		},
	}
}
</script>

<style scoped>

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {

	.contents__main--list {
		margin-left: 0% !important;
		margin-right: 0% !important;
		margin-top: 70px;
	}

	.ichiran__main {
		margin: 8px;
	}

	.ichiran__contents {
		margin-bottom: 8px;
		margin-left: auto;
		text-align: right;
	}

	.contents__research {
		position: relative;
	}

	.ichiran-back {
		table-layout: fixed;
	}

	.ichiran-back tr:nth-child(even) {
		background-color: #f1f2f5;
	}
  
	#link {
		text-decoration: none;
	}
	#listjyusho {
		padding: 10px 7px;
	}
	#listodd {
		background-color: #eeeeee;
		text-align: senter;
	}

	/* 入居人数(ヘッダ) */
	#listtitle01 {
		width: 8%;
		font-size: 16px;
	}

	/* 申込地区番号(ヘッダ) */
	#listtitle02 {
		width: 7%;
		font-size: 16px;
		padding: 5px 0px;
		line-height: 22px;
	}

	/* 住宅名(ヘッダ) */
	#listtitle03 {
		width: 22%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 募集戸数(ヘッダ) */
	#listtitle04 {
		width: 4%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 残戸数(ヘッダ) */
	#listtitle05 {
		width: 4%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 間取り(ヘッダ) */
	#listtitle06 {
		width: 8%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 建設年度(ヘッダ) */
	#listtitle07 {
		width: 12%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 使用料(ヘッダ) */
	#listtitle08 {
		width: 9%;
		font-size: 16px;
	}

	/* 状況(ヘッダ) */
	#listtitle09 {
		width: 8%;
		font-size: 16px;
	}

	/* 公開期間(ヘッダ) */
	#listtitle10 {
		width: 15%;
		font-size: 16px;
	}

	#list1 {
		font-weight: bold;
		font-size: 17px;
	}
	
	#list2 {
		font-weight: bold;
		font-size: 14px;
	}

	#list3 {
		font-size: 13px;
	}

	#listtdleft {
		text-align: left;
		font-size: 16px;
	}

	#listcountents {
		line-height: 20px !important;
	}

	#list tbody tr:hover td, #list tbody tr:hover th {
		background-color: #fff5d5;
	}

	.contents__koukai {
		background-color: #C1FFC1;
		color: #1D4B1F;
		font-size: 16px;
		margin: 5px 0;
		padding: 5px 13px;
		border-radius: 3px;
		line-height: 1.3em;
		font-weight: bold;
	}

	.contents__henkoyotei {
		background-color: #ffbdbd;
		color: #820000;
		font-size: 16px;
		margin: 5px 0;
		padding: 5px 5px;
		border-radius: 3px;
		line-height: 1.3em;
		font-weight: bold;
	}

	.contents__koukaisyuryo {
		background-color: #add8e6;
		color: #000000;
		font-size: 16px;
		margin: 5px 0;
		padding: 5px 5px;
		border-radius: 3px;
		line-height: 1.3em;
		font-weight: bold;
	}
	
	.contents__koukaiyotei {
		background-color: #ffff85;
		color: #503B00;
		font-size: 16px;
		margin: 5px 0;
		padding: 5px 5px;
		border-radius: 3px;
		line-height: 1.3em;
		font-weight: bold;
	}

}
</style>